@import 'abstract/variables';
@import 'abstract/colors';
@import 'abstract/mixins';

welcome-modal {
  display: none;

  &.active {
    position: fixed;
    z-index: 5000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .background {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba($dark-blue, 0.5);
    z-index: 10;
  }

  .close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 4px;
    right: 4px;
    width: 36px;
    height: 36px;
    padding: 0;
    cursor: pointer;
    border: none;
    background: none;
    z-index: 30;

    @include breakpoint(sm) {
      top: 4px;
      right: 4px;
    }

    &:before, &:after {
      position: absolute;
      width: 16px;
      height: 2px;
      content: "";
      transform: rotateZ(45deg);
      border-radius: 3px;
      background: $main-blue;
    }

    &:after {
      transform: rotateZ(-45deg);
    }
  }
}
